export enum UserRoles {
  student = "student",
  teacher = "teacher",
}

export enum UserPlan {
  free = "free",
  essentials = "essentials",
  clarity = "clarity",
  guidance = "guidance",
}

export type UserPlanAsLabel = "Free" | "Essentials" | "Clarity" | "Guidance";

export const mapUserPlanToLabel = (
  userPlan: UserPlan
): UserPlanAsLabel | undefined => {
  if (!Object.values(UserPlan).includes(userPlan)) {
    return undefined;
  }
  switch (userPlan) {
    case UserPlan.free:
      return "Free";
    case UserPlan.essentials:
      return "Essentials";
    case UserPlan.clarity:
      return "Clarity";
    case UserPlan.guidance:
      return "Guidance";
    default:
      /* eslint-disable-next-line  no-case-declarations */
      const exhaustiveCheck: never = userPlan;
      return undefined;
  }
};
